import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Icon from '../../system/Icon';
import colors from '../../../styles/colors';

const ContactInfo = ({ icon, label, info }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      padding: '24px 0px',
    }}
  >
    <Icon size="20px" name={icon} color={colors.primary.main} />
    <Box sx={{ marginLeft: '16px' }}>
      <Typography type="caption" sx={{ color: colors.text.tetriary }}>
        {label}
      </Typography>
      <Typography type="body2" sx={{ color: colors.text.primary }}>
        {info}
      </Typography>
    </Box>
  </Box>
);

export default ContactInfo;
